/**
 * Display name of the AI assistant. The panel title and the open and close
 * button labels all read from here, so the name a screen reader announces
 * cannot drift from the name on screen.
 */
const ASSISTANT_NAME = 'Civitas Learning AI'

export default ASSISTANT_NAME
